import { action } from "satcheljs";

const toggleHideScheduleAvailability = action(
    "toggleHideScheduleAvailability",
    () => ({})
);

export default toggleHideScheduleAvailability;